import {
    youtubeUrlRegex,
    BANNER_BLOG_MARKUP_PROPS,
    youtubeIframeMarkup,
} from "@constants";
import * as ReactDOMServer from "react-dom/server";
import React from "react";
import { CallToActionBanner, DiveInAction, EmailFormAction } from "../components/BW-Blog/components/ArticlePage/components";

export default class SearchForBlogSections {
    static searchForYoutubeSections(oldContent) {
        const matchedUrls = oldContent.match(youtubeUrlRegex);
        let content = oldContent;
        if (matchedUrls) {
            for (const matchedUrl of matchedUrls) {
                const clearUrl = matchedUrl.split('"></oembed>')[0];
                // we need to extract 11 digits of video's id
                let youtubeLinkId = clearUrl;
                if (youtubeLinkId.includes("watch?v=")) {
                    if (youtubeLinkId.includes("&")) {
                        youtubeLinkId = clearUrl.split("&")[0];
                    }
                    youtubeLinkId = youtubeLinkId.split("watch?v=")[1];
                } else {
                    youtubeLinkId = youtubeLinkId.split("/")[3];
                }
                // links to youtube in strapi with preview are wrapped in figure tag
                const linkInFigure = `<figure class="media"><oembed url="${clearUrl}"></oembed></figure>`;
                if (content.includes(linkInFigure)) {
                    content = content.replace(
                        linkInFigure,
                        youtubeIframeMarkup(youtubeLinkId)
                    );
                }
            }
        }
        return content;
    }

    static findBannerInMarkup(text) {
        let newText = text;
        let bannerIndex = 1;
        while (newText.includes("callToActionSection")) {
            const cutTag = text
                .split("&lt;callToActionSection")
                [bannerIndex].split("/&gt;")[0];
            const callToActionProps = {};
            if (cutTag.includes(BANNER_BLOG_MARKUP_PROPS.title)) {
                callToActionProps.title = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.title}="`)[1].split('"')[0];
            }
            if (cutTag.includes(BANNER_BLOG_MARKUP_PROPS.description)) {
                callToActionProps.description = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.description}="`)[1]
                    .split('"')[0];
            }
            if (cutTag.includes(BANNER_BLOG_MARKUP_PROPS.buttonText)) {
                callToActionProps.buttonText = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.buttonText}="`)[1].split('"')[0]
            }
            if (
                cutTag.includes(BANNER_BLOG_MARKUP_PROPS.buttonNavigationPath)
            ) {
                callToActionProps.buttonNavigationPath = cutTag
                    .split(
                        `${BANNER_BLOG_MARKUP_PROPS.buttonNavigationPath}="`
                    )[1]
                    .split('"')[0];
            }
            const banner = ReactDOMServer.renderToString(
                <CallToActionBanner {...callToActionProps} />
            );
            newText = newText.replace(
                `&lt;callToActionSection${cutTag}/&gt;`,
                banner
            );
            bannerIndex += 1;
        }
        return newText;
    }

    static findBannerIn(text) {
        let newText = text;
        let bannerIndex = 1;
        while (newText.includes("emailFormSection")) {
            const cutTag = text
                .split("&lt;emailFormSection")
                [bannerIndex].split("/&gt;")[0];
            const callToActionProps = {};
            if (cutTag.includes(BANNER_BLOG_MARKUP_PROPS.title)) {
                callToActionProps.title = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.title}="`)[1]
                    .split('"')[0];
            }
            if (cutTag.includes(BANNER_BLOG_MARKUP_PROPS.description)) {
                callToActionProps.description = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.description}="`)[1]
                    .split('"')[0];
            }
            if (cutTag.includes(BANNER_BLOG_MARKUP_PROPS.buttonText)) {
                callToActionProps.buttonText = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.buttonText}="`)[1]
                    .split('"')[0];
            }
            const banner = ReactDOMServer.renderToString(
                <EmailFormAction {...callToActionProps} />
            );
            newText = newText.replace(
                `&lt;emailFormSection${cutTag}/&gt;`,
                banner
            );
            bannerIndex += 1;
        }
        return newText;
    }

    static findDiveIn(text) {
        let newText = text;
        let bannerIndex = 1;
        while (newText?.includes("diveInActionSection")) {
            
            const cutTag = text
                ?.split("&lt;diveInActionSection")
                [bannerIndex]?.split("/&gt;")[0];
            const callToActionProps = {};
            if (cutTag?.includes(BANNER_BLOG_MARKUP_PROPS?.title)) {
                callToActionProps.title = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.title}="`)[1]
                    .split('"')[0];
            }
            if (cutTag?.includes(BANNER_BLOG_MARKUP_PROPS.description)) {
                callToActionProps.description = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.description}="`)[1]
                    .split('"')[0];
            }
            if (cutTag?.includes(BANNER_BLOG_MARKUP_PROPS.buttonText)) {
                callToActionProps.buttonText = cutTag
                    .split(`${BANNER_BLOG_MARKUP_PROPS.buttonText}="`)[1]
                    .split('"')[0];
            }
            if (
                cutTag?.includes(BANNER_BLOG_MARKUP_PROPS.buttonNavigationPath)
            ) {
                callToActionProps.buttonNavigationPath = cutTag
                    .split(
                        `${BANNER_BLOG_MARKUP_PROPS.buttonNavigationPath}="`
                    )[1]
                    .split('"')[0];
            }
            if (
                cutTag?.includes(BANNER_BLOG_MARKUP_PROPS.imageUrl)
            ) {
                callToActionProps.imageUrl = cutTag
                    .split(
                        `${BANNER_BLOG_MARKUP_PROPS.imageUrl}="`
                    )[1]
                    .split('"')[0];
            }
            const banner = ReactDOMServer.renderToString(
                <DiveInAction {...callToActionProps} />
            );
            newText = newText.replace(
                `&lt;diveInActionSection${cutTag}/&gt;`,
                banner
            );
            bannerIndex += 1;
        }
        return newText;
    }

    static replaceContentToMarkup(text) {
        const bannerResult = this.findBannerInMarkup(text);
        const formResult = this.findBannerIn(bannerResult);
        const diveResult = this.findDiveIn(formResult);

        return diveResult;
    }
}
